/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API Exporter
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddGenerateJobRequestDto } from '../models';
// @ts-ignore
import type { CreateExportTaskRequestDto } from '../models';
// @ts-ignore
import type { CreateSearchTaskRequestDto } from '../models';
// @ts-ignore
import type { ExportJobDto } from '../models';
// @ts-ignore
import type { ExportJobIdDto } from '../models';
// @ts-ignore
import type { ExportJobPageableResponseDto } from '../models';
// @ts-ignore
import type { ExportJobsByTaskIdRequestDto } from '../models';
// @ts-ignore
import type { ExportTaskDto } from '../models';
// @ts-ignore
import type { ExportTaskIdDto } from '../models';
// @ts-ignore
import type { ExportTaskPageableResponseDto } from '../models';
// @ts-ignore
import type { FanOutResponseDto } from '../models';
// @ts-ignore
import type { GetMyJobsRequestDto } from '../models';
// @ts-ignore
import type { GetMyJobsResponseDto } from '../models';
// @ts-ignore
import type { ImportRequestDto } from '../models';
// @ts-ignore
import type { OptionsDto } from '../models';
// @ts-ignore
import type { PageableRequestDto } from '../models';
// @ts-ignore
import type { StartExportTaskRequestDto } from '../models';
// @ts-ignore
import type { StartExportTaskResponseDto } from '../models';
// @ts-ignore
import type { StartSearchTaskResponseDto } from '../models';
// @ts-ignore
import type { TemplatePreviewRequestDto } from '../models';
// @ts-ignore
import type { TemplatePreviewResponseDto } from '../models';
// @ts-ignore
import type { TemplateVariablesResponseDto } from '../models';
// @ts-ignore
import type { UpdateDataExportTaskRequestDto } from '../models';
/**
 * QueuesApi - axios parameter creator
 * @export
 */
export const QueuesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Отмена задачи на выгрузку
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerAbortJobById: async (exportTaskIdDto: ExportTaskIdDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportTaskIdDto' is not null or undefined
            assertParamExists('exportControllerAbortJobById', 'exportTaskIdDto', exportTaskIdDto)
            const localVarPath = `/export/abortJobById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportTaskIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создание задачи на выгрузку
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerCreateExportTask: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/export/createExportTask`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удаление повторяющейся задачи
         * @param {ExportJobIdDto} exportJobIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerDeleteExportRepeatableJob: async (exportJobIdDto: ExportJobIdDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportJobIdDto' is not null or undefined
            assertParamExists('exportControllerDeleteExportRepeatableJob', 'exportJobIdDto', exportJobIdDto)
            const localVarPath = `/export/deleteExportRepeatableJob`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportJobIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удаление задачи на выгрузку
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerDeleteExportTask: async (exportTaskIdDto: ExportTaskIdDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportTaskIdDto' is not null or undefined
            assertParamExists('exportControllerDeleteExportTask', 'exportTaskIdDto', exportTaskIdDto)
            const localVarPath = `/export/deleteExportTask`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportTaskIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные по задаче по id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetExportTaskById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exportControllerGetExportTaskById', 'id', id)
            const localVarPath = `/export/task/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить параметры задачи
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetExportTaskOptions: async (exportTaskIdDto: ExportTaskIdDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportTaskIdDto' is not null or undefined
            assertParamExists('exportControllerGetExportTaskOptions', 'exportTaskIdDto', exportTaskIdDto)
            const localVarPath = `/export/getExportTaskOptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportTaskIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить список джобов по задаче
         * @param {ExportJobsByTaskIdRequestDto} exportJobsByTaskIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetMyExportJobsByTaskId: async (exportJobsByTaskIdRequestDto: ExportJobsByTaskIdRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportJobsByTaskIdRequestDto' is not null or undefined
            assertParamExists('exportControllerGetMyExportJobsByTaskId', 'exportJobsByTaskIdRequestDto', exportJobsByTaskIdRequestDto)
            const localVarPath = `/export/getMyExportJobsByTaskId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportJobsByTaskIdRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Тот же ExportTaskDto, что и в списке (с lastRunAt/lastRunStatus/jobStats), для детальной страницы — без подгрузки всей страницы списка.
         * @summary Получить задачу по id с метаданными запусков
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetMyExportTaskById: async (exportTaskIdDto: ExportTaskIdDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportTaskIdDto' is not null or undefined
            assertParamExists('exportControllerGetMyExportTaskById', 'exportTaskIdDto', exportTaskIdDto)
            const localVarPath = `/export/getMyExportTaskById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportTaskIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить список своих задач
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetMyExportTasks: async (pageableRequestDto: PageableRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageableRequestDto' is not null or undefined
            assertParamExists('exportControllerGetMyExportTasks', 'pageableRequestDto', pageableRequestDto)
            const localVarPath = `/export/getMyExportTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pageableRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Глобальный список jobs (для экрана «Все запуски»). Пагинация + опциональные фильтры status/taskId/format/dateFrom/dateTo. Сортировка по createdAt desc.
         * @summary Получить список запусков по всем своим задачам
         * @param {GetMyJobsRequestDto} getMyJobsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetMyJobs: async (getMyJobsRequestDto: GetMyJobsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getMyJobsRequestDto' is not null or undefined
            assertParamExists('exportControllerGetMyJobs', 'getMyJobsRequestDto', getMyJobsRequestDto)
            const localVarPath = `/export/getMyJobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getMyJobsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает разрешённые плейсхолдеры (scalar-поля по категориям + коллекции params/properties). Используется фронтом для построения сайдбара с подсказками и автокомплита.
         * @summary Список переменных для шаблонов title/description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetTemplateVariables: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/export/template-variables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить данные для формы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerOptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/export/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Принимает сэмплы товаров (фронт уже имеет данные каталога) и шаблоны, возвращает per-product before/after/usedVars/missingVars. Не ходит в product-storage. Ошибки парсинга шаблона возвращаются 400 с offset\'ом.
         * @summary Preview шаблонов title/description на сэмплах товаров
         * @param {TemplatePreviewRequestDto} templatePreviewRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerPreviewTemplate: async (templatePreviewRequestDto: TemplatePreviewRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templatePreviewRequestDto' is not null or undefined
            assertParamExists('exportControllerPreviewTemplate', 'templatePreviewRequestDto', templatePreviewRequestDto)
            const localVarPath = `/export/template-preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(templatePreviewRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Перезапустить задачу
         * @param {ExportJobIdDto} exportJobIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerRetryExportJob: async (exportJobIdDto: ExportJobIdDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportJobIdDto' is not null or undefined
            assertParamExists('exportControllerRetryExportJob', 'exportJobIdDto', exportJobIdDto)
            const localVarPath = `/export/retryExportJob`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportJobIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Запуск задачи на выгрузку
         * @param {StartExportTaskRequestDto} startExportTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerStartExportTask: async (startExportTaskRequestDto: StartExportTaskRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startExportTaskRequestDto' is not null or undefined
            assertParamExists('exportControllerStartExportTask', 'startExportTaskRequestDto', startExportTaskRequestDto)
            const localVarPath = `/export/startExportTask`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startExportTaskRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновление данных задачи
         * @param {UpdateDataExportTaskRequestDto} updateDataExportTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerUpdateExportTask: async (updateDataExportTaskRequestDto: UpdateDataExportTaskRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDataExportTaskRequestDto' is not null or undefined
            assertParamExists('exportControllerUpdateExportTask', 'updateDataExportTaskRequestDto', updateDataExportTaskRequestDto)
            const localVarPath = `/export/updateExportTask`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDataExportTaskRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Запуск задачи на выгрузку spuId по поисковому запросу (admin-only)
         * @param {CreateSearchTaskRequestDto} createSearchTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSearchControllerStart: async (createSearchTaskRequestDto: CreateSearchTaskRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSearchTaskRequestDto' is not null or undefined
            assertParamExists('exportSearchControllerStart', 'createSearchTaskRequestDto', createSearchTaskRequestDto)
            const localVarPath = `/export-search/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSearchTaskRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Запуск задачи
         * @param {AddGenerateJobRequestDto} addGenerateJobRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        llmProductContentControllerAddGenerateJob: async (addGenerateJobRequestDto: AddGenerateJobRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addGenerateJobRequestDto' is not null or undefined
            assertParamExists('llmProductContentControllerAddGenerateJob', 'addGenerateJobRequestDto', addGenerateJobRequestDto)
            const localVarPath = `/llm/addGenerateJob`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addGenerateJobRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Запуск задачи
         * @param {ImportRequestDto} importRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseAndImportProductsControllerStartImportTask: async (importRequestDto: ImportRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importRequestDto' is not null or undefined
            assertParamExists('parseAndImportProductsControllerStartImportTask', 'importRequestDto', importRequestDto)
            const localVarPath = `/import/startImportTask`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поставить в очередь квартальные Wordstat-снимки для всех товаров (admin-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordstatQuarterlySnapshotControllerFanOut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/queues/wordstat-quarterly-snapshot/fanOut`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueuesApi - functional programming interface
 * @export
 */
export const QueuesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QueuesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Отмена задачи на выгрузку
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerAbortJobById(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerAbortJobById(exportTaskIdDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerAbortJobById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Создание задачи на выгрузку
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerCreateExportTask(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateExportTaskRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerCreateExportTask(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerCreateExportTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удаление повторяющейся задачи
         * @param {ExportJobIdDto} exportJobIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerDeleteExportRepeatableJob(exportJobIdDto: ExportJobIdDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerDeleteExportRepeatableJob(exportJobIdDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerDeleteExportRepeatableJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удаление задачи на выгрузку
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerDeleteExportTask(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerDeleteExportTask(exportTaskIdDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerDeleteExportTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные по задаче по id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerGetExportTaskById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerGetExportTaskById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerGetExportTaskById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить параметры задачи
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerGetExportTaskOptions(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateExportTaskRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerGetExportTaskOptions(exportTaskIdDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerGetExportTaskOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить список джобов по задаче
         * @param {ExportJobsByTaskIdRequestDto} exportJobsByTaskIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerGetMyExportJobsByTaskId(exportJobsByTaskIdRequestDto: ExportJobsByTaskIdRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerGetMyExportJobsByTaskId(exportJobsByTaskIdRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerGetMyExportJobsByTaskId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Тот же ExportTaskDto, что и в списке (с lastRunAt/lastRunStatus/jobStats), для детальной страницы — без подгрузки всей страницы списка.
         * @summary Получить задачу по id с метаданными запусков
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerGetMyExportTaskById(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportTaskDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerGetMyExportTaskById(exportTaskIdDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerGetMyExportTaskById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить список своих задач
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerGetMyExportTasks(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportTaskPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerGetMyExportTasks(pageableRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerGetMyExportTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Глобальный список jobs (для экрана «Все запуски»). Пагинация + опциональные фильтры status/taskId/format/dateFrom/dateTo. Сортировка по createdAt desc.
         * @summary Получить список запусков по всем своим задачам
         * @param {GetMyJobsRequestDto} getMyJobsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerGetMyJobs(getMyJobsRequestDto: GetMyJobsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyJobsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerGetMyJobs(getMyJobsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerGetMyJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает разрешённые плейсхолдеры (scalar-поля по категориям + коллекции params/properties). Используется фронтом для построения сайдбара с подсказками и автокомплита.
         * @summary Список переменных для шаблонов title/description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerGetTemplateVariables(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateVariablesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerGetTemplateVariables(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerGetTemplateVariables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить данные для формы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerOptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OptionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerOptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Принимает сэмплы товаров (фронт уже имеет данные каталога) и шаблоны, возвращает per-product before/after/usedVars/missingVars. Не ходит в product-storage. Ошибки парсинга шаблона возвращаются 400 с offset\'ом.
         * @summary Preview шаблонов title/description на сэмплах товаров
         * @param {TemplatePreviewRequestDto} templatePreviewRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerPreviewTemplate(templatePreviewRequestDto: TemplatePreviewRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplatePreviewResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerPreviewTemplate(templatePreviewRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerPreviewTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Перезапустить задачу
         * @param {ExportJobIdDto} exportJobIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerRetryExportJob(exportJobIdDto: ExportJobIdDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerRetryExportJob(exportJobIdDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerRetryExportJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Запуск задачи на выгрузку
         * @param {StartExportTaskRequestDto} startExportTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerStartExportTask(startExportTaskRequestDto: StartExportTaskRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartExportTaskResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerStartExportTask(startExportTaskRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerStartExportTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновление данных задачи
         * @param {UpdateDataExportTaskRequestDto} updateDataExportTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportControllerUpdateExportTask(updateDataExportTaskRequestDto: UpdateDataExportTaskRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportTaskDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerUpdateExportTask(updateDataExportTaskRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportControllerUpdateExportTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Запуск задачи на выгрузку spuId по поисковому запросу (admin-only)
         * @param {CreateSearchTaskRequestDto} createSearchTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportSearchControllerStart(createSearchTaskRequestDto: CreateSearchTaskRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartSearchTaskResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportSearchControllerStart(createSearchTaskRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.exportSearchControllerStart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Запуск задачи
         * @param {AddGenerateJobRequestDto} addGenerateJobRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async llmProductContentControllerAddGenerateJob(addGenerateJobRequestDto: AddGenerateJobRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.llmProductContentControllerAddGenerateJob(addGenerateJobRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.llmProductContentControllerAddGenerateJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Запуск задачи
         * @param {ImportRequestDto} importRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parseAndImportProductsControllerStartImportTask(importRequestDto: ImportRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parseAndImportProductsControllerStartImportTask(importRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.parseAndImportProductsControllerStartImportTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поставить в очередь квартальные Wordstat-снимки для всех товаров (admin-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wordstatQuarterlySnapshotControllerFanOut(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FanOutResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wordstatQuarterlySnapshotControllerFanOut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueuesApi.wordstatQuarterlySnapshotControllerFanOut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QueuesApi - factory interface
 * @export
 */
export const QueuesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QueuesApiFp(configuration)
    return {
        /**
         * 
         * @summary Отмена задачи на выгрузку
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerAbortJobById(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.exportControllerAbortJobById(exportTaskIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создание задачи на выгрузку
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerCreateExportTask(options?: RawAxiosRequestConfig): AxiosPromise<CreateExportTaskRequestDto> {
            return localVarFp.exportControllerCreateExportTask(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удаление повторяющейся задачи
         * @param {ExportJobIdDto} exportJobIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerDeleteExportRepeatableJob(exportJobIdDto: ExportJobIdDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.exportControllerDeleteExportRepeatableJob(exportJobIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удаление задачи на выгрузку
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerDeleteExportTask(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.exportControllerDeleteExportTask(exportTaskIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные по задаче по id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetExportTaskById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobDto> {
            return localVarFp.exportControllerGetExportTaskById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить параметры задачи
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetExportTaskOptions(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateExportTaskRequestDto> {
            return localVarFp.exportControllerGetExportTaskOptions(exportTaskIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить список джобов по задаче
         * @param {ExportJobsByTaskIdRequestDto} exportJobsByTaskIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetMyExportJobsByTaskId(exportJobsByTaskIdRequestDto: ExportJobsByTaskIdRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobPageableResponseDto> {
            return localVarFp.exportControllerGetMyExportJobsByTaskId(exportJobsByTaskIdRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Тот же ExportTaskDto, что и в списке (с lastRunAt/lastRunStatus/jobStats), для детальной страницы — без подгрузки всей страницы списка.
         * @summary Получить задачу по id с метаданными запусков
         * @param {ExportTaskIdDto} exportTaskIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetMyExportTaskById(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig): AxiosPromise<ExportTaskDto> {
            return localVarFp.exportControllerGetMyExportTaskById(exportTaskIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить список своих задач
         * @param {PageableRequestDto} pageableRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetMyExportTasks(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExportTaskPageableResponseDto> {
            return localVarFp.exportControllerGetMyExportTasks(pageableRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Глобальный список jobs (для экрана «Все запуски»). Пагинация + опциональные фильтры status/taskId/format/dateFrom/dateTo. Сортировка по createdAt desc.
         * @summary Получить список запусков по всем своим задачам
         * @param {GetMyJobsRequestDto} getMyJobsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetMyJobs(getMyJobsRequestDto: GetMyJobsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GetMyJobsResponseDto> {
            return localVarFp.exportControllerGetMyJobs(getMyJobsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает разрешённые плейсхолдеры (scalar-поля по категориям + коллекции params/properties). Используется фронтом для построения сайдбара с подсказками и автокомплита.
         * @summary Список переменных для шаблонов title/description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerGetTemplateVariables(options?: RawAxiosRequestConfig): AxiosPromise<TemplateVariablesResponseDto> {
            return localVarFp.exportControllerGetTemplateVariables(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить данные для формы
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerOptions(options?: RawAxiosRequestConfig): AxiosPromise<OptionsDto> {
            return localVarFp.exportControllerOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * Принимает сэмплы товаров (фронт уже имеет данные каталога) и шаблоны, возвращает per-product before/after/usedVars/missingVars. Не ходит в product-storage. Ошибки парсинга шаблона возвращаются 400 с offset\'ом.
         * @summary Preview шаблонов title/description на сэмплах товаров
         * @param {TemplatePreviewRequestDto} templatePreviewRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerPreviewTemplate(templatePreviewRequestDto: TemplatePreviewRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TemplatePreviewResponseDto> {
            return localVarFp.exportControllerPreviewTemplate(templatePreviewRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Перезапустить задачу
         * @param {ExportJobIdDto} exportJobIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerRetryExportJob(exportJobIdDto: ExportJobIdDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.exportControllerRetryExportJob(exportJobIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Запуск задачи на выгрузку
         * @param {StartExportTaskRequestDto} startExportTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerStartExportTask(startExportTaskRequestDto: StartExportTaskRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<StartExportTaskResponseDto> {
            return localVarFp.exportControllerStartExportTask(startExportTaskRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновление данных задачи
         * @param {UpdateDataExportTaskRequestDto} updateDataExportTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportControllerUpdateExportTask(updateDataExportTaskRequestDto: UpdateDataExportTaskRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExportTaskDto> {
            return localVarFp.exportControllerUpdateExportTask(updateDataExportTaskRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Запуск задачи на выгрузку spuId по поисковому запросу (admin-only)
         * @param {CreateSearchTaskRequestDto} createSearchTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSearchControllerStart(createSearchTaskRequestDto: CreateSearchTaskRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<StartSearchTaskResponseDto> {
            return localVarFp.exportSearchControllerStart(createSearchTaskRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Запуск задачи
         * @param {AddGenerateJobRequestDto} addGenerateJobRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        llmProductContentControllerAddGenerateJob(addGenerateJobRequestDto: AddGenerateJobRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.llmProductContentControllerAddGenerateJob(addGenerateJobRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Запуск задачи
         * @param {ImportRequestDto} importRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseAndImportProductsControllerStartImportTask(importRequestDto: ImportRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.parseAndImportProductsControllerStartImportTask(importRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поставить в очередь квартальные Wordstat-снимки для всех товаров (admin-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordstatQuarterlySnapshotControllerFanOut(options?: RawAxiosRequestConfig): AxiosPromise<FanOutResponseDto> {
            return localVarFp.wordstatQuarterlySnapshotControllerFanOut(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QueuesApi - object-oriented interface
 * @export
 * @class QueuesApi
 * @extends {BaseAPI}
 */
export class QueuesApi extends BaseAPI {
    /**
     * 
     * @summary Отмена задачи на выгрузку
     * @param {ExportTaskIdDto} exportTaskIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerAbortJobById(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerAbortJobById(exportTaskIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создание задачи на выгрузку
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerCreateExportTask(options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerCreateExportTask(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удаление повторяющейся задачи
     * @param {ExportJobIdDto} exportJobIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerDeleteExportRepeatableJob(exportJobIdDto: ExportJobIdDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerDeleteExportRepeatableJob(exportJobIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удаление задачи на выгрузку
     * @param {ExportTaskIdDto} exportTaskIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerDeleteExportTask(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerDeleteExportTask(exportTaskIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные по задаче по id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerGetExportTaskById(id: string, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerGetExportTaskById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить параметры задачи
     * @param {ExportTaskIdDto} exportTaskIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerGetExportTaskOptions(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerGetExportTaskOptions(exportTaskIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить список джобов по задаче
     * @param {ExportJobsByTaskIdRequestDto} exportJobsByTaskIdRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerGetMyExportJobsByTaskId(exportJobsByTaskIdRequestDto: ExportJobsByTaskIdRequestDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerGetMyExportJobsByTaskId(exportJobsByTaskIdRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Тот же ExportTaskDto, что и в списке (с lastRunAt/lastRunStatus/jobStats), для детальной страницы — без подгрузки всей страницы списка.
     * @summary Получить задачу по id с метаданными запусков
     * @param {ExportTaskIdDto} exportTaskIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerGetMyExportTaskById(exportTaskIdDto: ExportTaskIdDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerGetMyExportTaskById(exportTaskIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить список своих задач
     * @param {PageableRequestDto} pageableRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerGetMyExportTasks(pageableRequestDto: PageableRequestDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerGetMyExportTasks(pageableRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Глобальный список jobs (для экрана «Все запуски»). Пагинация + опциональные фильтры status/taskId/format/dateFrom/dateTo. Сортировка по createdAt desc.
     * @summary Получить список запусков по всем своим задачам
     * @param {GetMyJobsRequestDto} getMyJobsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerGetMyJobs(getMyJobsRequestDto: GetMyJobsRequestDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerGetMyJobs(getMyJobsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает разрешённые плейсхолдеры (scalar-поля по категориям + коллекции params/properties). Используется фронтом для построения сайдбара с подсказками и автокомплита.
     * @summary Список переменных для шаблонов title/description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerGetTemplateVariables(options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerGetTemplateVariables(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить данные для формы
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerOptions(options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Принимает сэмплы товаров (фронт уже имеет данные каталога) и шаблоны, возвращает per-product before/after/usedVars/missingVars. Не ходит в product-storage. Ошибки парсинга шаблона возвращаются 400 с offset\'ом.
     * @summary Preview шаблонов title/description на сэмплах товаров
     * @param {TemplatePreviewRequestDto} templatePreviewRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerPreviewTemplate(templatePreviewRequestDto: TemplatePreviewRequestDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerPreviewTemplate(templatePreviewRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Перезапустить задачу
     * @param {ExportJobIdDto} exportJobIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerRetryExportJob(exportJobIdDto: ExportJobIdDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerRetryExportJob(exportJobIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Запуск задачи на выгрузку
     * @param {StartExportTaskRequestDto} startExportTaskRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerStartExportTask(startExportTaskRequestDto: StartExportTaskRequestDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerStartExportTask(startExportTaskRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновление данных задачи
     * @param {UpdateDataExportTaskRequestDto} updateDataExportTaskRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportControllerUpdateExportTask(updateDataExportTaskRequestDto: UpdateDataExportTaskRequestDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportControllerUpdateExportTask(updateDataExportTaskRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Запуск задачи на выгрузку spuId по поисковому запросу (admin-only)
     * @param {CreateSearchTaskRequestDto} createSearchTaskRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public exportSearchControllerStart(createSearchTaskRequestDto: CreateSearchTaskRequestDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).exportSearchControllerStart(createSearchTaskRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Запуск задачи
     * @param {AddGenerateJobRequestDto} addGenerateJobRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public llmProductContentControllerAddGenerateJob(addGenerateJobRequestDto: AddGenerateJobRequestDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).llmProductContentControllerAddGenerateJob(addGenerateJobRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Запуск задачи
     * @param {ImportRequestDto} importRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public parseAndImportProductsControllerStartImportTask(importRequestDto: ImportRequestDto, options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).parseAndImportProductsControllerStartImportTask(importRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поставить в очередь квартальные Wordstat-снимки для всех товаров (admin-only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueuesApi
     */
    public wordstatQuarterlySnapshotControllerFanOut(options?: RawAxiosRequestConfig) {
        return QueuesApiFp(this.configuration).wordstatQuarterlySnapshotControllerFanOut(options).then((request) => request(this.axios, this.basePath));
    }
}

